import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeExcludedFilter, showExcluded } from '../../utils/filter';
import {
	selectRawFilter,
	selectPolygonFilter,
	selectExcludedList,
	setPolygonFilterAction,
	setFilterModelAction,
	addExcludedItemAction,
	removeExcludedItemAction,
	clearFiltersAction,
} from './filterSlice';
import { GridFilterModel } from '@mui/x-data-grid';

export const useFilters = () => {
	const dispatch = useDispatch();
	const rawFilter = useSelector(selectRawFilter);
	const polygonFilter = useSelector(selectPolygonFilter);
	const excludedList = useSelector(selectExcludedList);

	const excludedFilter = useMemo(
		() =>
			excludedList.length > 0
				? {
						showExcludedOnly: showExcluded(rawFilter),
						excludedIds: excludedList,
				  }
				: undefined,
		[rawFilter, excludedList],
	);

	const filterCount =
		removeExcludedFilter(rawFilter).items.length + (excludedFilter ? 1 : 0);

	return {
		rawFilter,
		polygonFilter,
		excludedFilter,
		filterCount,
		setPolygonFilter: useCallback(
			(p: GeoJSON.Feature<GeoJSON.Polygon> | undefined) =>
				dispatch(setPolygonFilterAction(p)),
			[dispatch],
		),
		setFilterModel: useCallback(
			(m: GridFilterModel) => dispatch(setFilterModelAction(m)),
			[dispatch],
		),
		addExcludedItem: useCallback(
			(id: string) => dispatch(addExcludedItemAction(id)),
			[dispatch],
		),
		removeExcludedItem: useCallback(
			(id: string) => dispatch(removeExcludedItemAction(id)),
			[dispatch],
		),
		clearFilters: useCallback(() => dispatch(clearFiltersAction()), [dispatch]),
	};
};
